module.exports = __webpack_public_path__ + "static/media/corporate_fare_sponsor.678ea68a.svg";